<template>
  <div class="baColor">
    <div class="damandList">
      <div class="damandList_box w1200Auto">
        <div class="flex-item-center breadcrumb">
          <span style="font-size: 14px; padding-left: 5px">当前位置：</span>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/supplyHome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item style="cursor: pointer" :to="{ name: 'supplyHome' }"
              >供需对接</el-breadcrumb-item
            >
            <el-breadcrumb-item style="color: #009999"
              >服务列表</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <h1 class="title">服务列表</h1>
        <div class="searchContainer">
          <!-- 分类 -->
          <div class="print_screen_box flex" style="position: relative">
            <div style="width: 100%; color: #6e6e6e">
              <!-- 所属地区： -->
              <div style="display: flex">
                <p class="print_title">行业分类：</p>
                <div class="print_screen_boxP" style="margin-bottom: 6px">
                  <p
                    v-model="classifyOne"
                    v-for="(items, index) in oneServiceList"
                    :key="index"
                    :class="printScreenTwoIndex == index ? 'screen_text' : ''"
                    @click="changeScreenTwo(index, items)"
                    style="cursor: pointer"
                  >
                    {{ items.cdLabel }}
                  </p>
                </div>
              </div>
              <!-- 二级分类 -->
              <div
                class="flex"
                style="
                  padding: 15px 15px 5px;
                  background: #f5f7fa;
                  color: #6e6e6e;
                  margin-left: 93px;
                  display: flex;
                  flex-wrap: wrap;
                "
                v-show="classShow"
              >
                <p
                  v-for="(items, index) in twoServiceList"
                  :key="index"
                  :class="printScreenThreeIndex == index ? 'materDetailsT' : ''"
                  @click="changeScreenThree(index, items)"
                  style="cursor: pointer"
                >
                  {{ items.cdLabel }}
                </p>
              </div>
              <!-- 需求分类： -->
              <div style="display: flex; margin-top: 15px">
                <p class="print_title">服务分类：</p>
                <div class="print_screen_boxP">
                  <p
                    v-for="(items, index) in fwlxType"
                    :key="index"
                    @click="changeScreen(index, items)"
                    :class="printScreenIndex == index ? 'screen_text' : ''"
                  >
                    {{ items.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 搜索 -->
          <div class="flex searchContainerone">
            <p class="print_title">服务名：</p>
            <el-input
              placeholder="请输入服务名"
              v-model="title"
              class="input-with-select"
              clearable
              prefix-icon="el-icon-search"
            >
            </el-input>
            <el-button type="primary" @click="handleCurrentChange()">
              搜索
            </el-button>
          </div>
        </div>
        <div class="flex-item-center demande_news">
          <p class="demande_title">排序：</p>
          <div
            class="demande_shai"
            v-for="(item, index) in sortList"
            :key="index"
            @click="onClickSort(item)"
          >
            <span class="shai_name" :class="item.className">{{
              item.name
            }}</span>
            <div class="demande_shai_i">
              <i class="el-icon-caret-top" :class="item.iconsColorShow? item.className : ''"></i>
              <i class="el-icon-caret-bottom"  :class="!item.iconsColorShow? item.className : ''"></i>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <serviceListMessage ref="serviceListInfoRef"></serviceListMessage>
      </div>
    </div>
  </div>
</template>

  <script>
import serviceListMessage from "./serviceListMessage";
import {ajaxFindServiceAbility, getIndexDictionaryData, serviceListPage} from "../../../../utils/interface";
export default {
  components: {
    serviceListMessage,
  },
  data() {
    return {
      title: "",
      printScreenIndex: "0",
      printScreenTwoIndex: "0",
      printScreenThreeIndex: null,
      fwlxType: [],
      oneServiceList:[],
      twoServiceList:[],
      threeServiceList:[],
      fourServiceList:[],
      classShow: false,
      checked: false,
      classifyOne:"",
      classifyTwo:"",
      type:"",
      sortList: [
        {
          name: "发布时间",
          className: "",
          iconsColorShow: "",
        },
        {
          name: "好评",
          className: "",
          iconsColorShow: "",
        },
        {
          name: "服务价格",
          className: "",
          iconsColorShow: "",
        },
      ],
    };
  },
  created() {
    this.initDitc();
    this.classifyOne = this.$route.params.classifyOne;
    this.classifyTwo = this.$route.params.classifyTwo;
    this.publishDate = true;
    this.publishDateorderBy = "desc";
    setTimeout(() => {
      if(this.classifyOne) {
        this.oneServiceList.map((item,index) => {
          if(item.cdClass == this.classifyOne) {
            this.printScreenTwoIndex = index
          }
        })
        if(this.classifyTwo) {
          ajaxFindServiceAbility({cdRank:'2',cdClass:this.classifyOne}).then((res)=>{
            this.twoServiceList = res.tasks;
            this.twoServiceList.map((item,index) => {
              if(item.cdClass == this.classifyTwo) {
                this.printScreenThreeIndex = index
                this.classShow = true;
              }
            })
          });
        }
      }
      this.handleCurrentChange();
    }, 500);
  },
  methods: {
    initDitc(){
      this.serviceAbilityInfo("1");
      getIndexDictionaryData({groupCode: "FWLX"}).then((res)=>{
        this.fwlxType = res
        this.fwlxType.unshift({
            name: "全部"
          })
      })
    },
    serviceAbilityInfo(rank,cdClass){
      if(rank=="1"){
        ajaxFindServiceAbility({cdRank:rank}).then((res)=>{
          this.oneServiceList = res.tasks;
          this.oneServiceList.unshift({
            cdClass: "",
            cdId: "",
            cdLabel: "全部"
          })
          //显示传参对应分类
          /*if(this.$route.params.classifyOne){
            let filterIndex = this.oneServiceList.findIndex((ele)=>ele.cdClass == this.$route.params.classifyOne)
            if(filterIndex != -1){
              this.printScreenTwoIndex = filterIndex
              this.changeScreenTwo(filterIndex,this.oneServiceList[filterIndex])
            }
          }*/
        });
      }else if(rank=="2"){
        ajaxFindServiceAbility({cdRank:rank,cdClass:cdClass}).then((res)=>{
          this.twoServiceList = res.tasks;
           //显示传参对应分类
          if(this.$route.params.classifyTwo){
            let filterIndex = this.twoServiceList.findIndex((ele)=>ele.cdClass == this.$route.params.classifyTwo)
            if(filterIndex !=-1){
              this.printScreenThreeIndex = filterIndex
            }
          }
          if(res.tasks && cdClass){
            this.classShow = true;
          }else {
            this.classShow = false;
          }
        });
      }


    },
    changeScreen(index, item) {
      this.printScreenIndex = index;
      this.type = item.name;
      this.handleCurrentChange();
    },
    changeScreenTwo(index, item) {
      this.printScreenTwoIndex = index;
      this.classifyOne = item.cdClass;
      this.printScreenThreeIndex = null;
      this.classifyTwo = ""
      this.serviceAbilityInfo("2",item.cdClass)
      this.handleCurrentChange();
    },
    changeScreenThree(index, item) {
      this.printScreenThreeIndex = index;
      this.classifyTwo = item.cdClass;
      this.handleCurrentChange();
    },
    onClickSort(item) {
      if(item.name=="发布时间"){
        this.publishDate="true";
        if(item.iconsColorShow){
          this.publishDateorderBy = "desc";
        }else {
          this.publishDateorderBy = "asc";
        }
        this.pjNum="";
        this.pjNumorderBy = "";
        this.sortList[1].iconsColorShow='';
        this.sortList[1].className='';

        this.price="";
        this.priceorderBy = "";
        this.sortList[2].iconsColorShow='';
        this.sortList[2].className='';
      }
      if(item.name=="好评"){
        this.pjNum="true";
        if(item.iconsColorShow){
          this.pjNumorderBy = "desc";
        }else {
          this.pjNumorderBy = "asc";
        }
        this.publishDate="";
        this.publishDateorderBy = "";
        this.sortList[0].iconsColorShow='';
        this.sortList[0].className='';

        this.price="";
        this.priceorderBy = "";
        this.sortList[2].iconsColorShow='';
        this.sortList[2].className='';
      }
      if(item.name=="服务价格"){
        this.price="true";
        if(item.iconsColorShow){
          this.priceorderBy = "desc";
        }else {
          this.priceorderBy = "asc";
        }
        this.pjNum="";
        this.pjNumorderBy = "";
        this.sortList[1].iconsColorShow='';
        this.sortList[1].className='';

        this.publishDate="";
        this.publishDateorderBy = "";
        this.sortList[0].iconsColorShow='';
        this.sortList[0].className='';
      }
        item.iconsColorShow = !item.iconsColorShow
        item.className = "shai_name_active";
      this.handleCurrentChange();
    },
    openDemand() {
      let routeData = this.$url.buyerWeb + `#/publishDemand`;
      if (routeData != "") {
        window.open(routeData, "_blank");
      }
    },
    handleCurrentChange(){
      let param={
        title:this.title,
        classifyOne:this.classifyOne,
        classifyTwo:this.classifyTwo,
        type:this.type,
        publishDate:this.publishDate,
        publishDateorderBy:this.publishDateorderBy,
        pjNum:this.pjNum,
        pjNumorderBy:this.pjNumorderBy,
        price:this.price,
        priceorderBy:this.priceorderBy,
      };
      this.$refs.serviceListInfoRef.init(param);
    }
  },
};
</script>

  <style lang="less" scoped>
@import "../../style/index.less";
.damandList {
  background: #f5f7fa;
}
.damandList_box {
  padding: 20px;
  .title {
    font-size: 28px;
    color: #1d1d1d;
    margin: 20px 0 30px;
  }
}
.searchContainer {
  background: #fff;
  padding: 20px 30px;
  padding-top: 26px;
  .searchContainerone {
    margin-top: 15px;
    display: flex;
    align-items: center;
    .searchContainerButton {
      color: #009999;
      margin-left: 60px;
      border: 1px solid #009999;
      background: #fff;
      font-size: 14px;
    }
    button {
      width: 90px;
      border-radius: 8px;
    }
  }
  /deep/.el-input {
    width: 500px;
    margin-right: 10px;
  }
  /deep/ .input-with-select .el-input__inner {
    background: #fdfdfd;
    border: 1px solid #cecece;
    height: 40px;
    border-radius: 8px;
    line-height: 40px;
    width: 500px;
  }

  ul {
    display: flex;
    align-items: center;
    width: 812px;
    padding-left: 3px;
    margin: 0 auto;
    margin-bottom: 15px;
    img {
      width: 20px;
    }
    li {
      font-size: 12px;
      margin-top: 10px;
      padding: 0 15px;

      &.textLi {
        cursor: pointer;

        &:hover {
          color: #009999;
        }
      }
    }
  }
}
.print_title {
  flex-shrink: 0;
  padding-right: 19px;
  padding-left: 0px;
  color: #000;
  font-weight: 500;
  font-size: 14px;
  width: 80px;
  text-align: right;
}
.print_screen_box {
  background: #fff;
  padding: 0 15px 0 0;
  box-sizing: border-box;

  .print_title {
    flex-shrink: 0;
    padding-right: 41px;
    padding-left: 0px;
    color: #000;
    font-weight: 500;
  }

  .print_screen_boxP {
    display: flex;
    flex-wrap: wrap;
    margin-left: -29px;
    p {
      cursor: pointer;
    }

    .screen_text {
      color: #009999;
      border-radius: 5px;
      margin-bottom: 10px;
      padding: 3px 15px;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .screen_text {
    color: #009999;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 3px 15px;
    font-size: 14px;
  }

  p {
    margin-bottom: 10px;
    margin-right: 0px;
    padding: 3px 14px;
    font-size: 14px;
  }

  .materDetailsT {
    // background: #009999;
    color: #009999;
    border-radius: 5px;
    padding: 3px 15px;
    margin-bottom: 10px;
  }
}
.demande_news {
  padding: 20px 30px;
  flex-shrink: 0;
  background: #fff;
  margin-top: 10px;
  font-size: 14px;
  .demande_title {
    margin-right: 30px;
    font-weight: 500;
  }
  .demande_shai {
    margin-right: 30px;
    color: #6E6E6E;
    display: flex;
    align-items: center;
    .demande_shai_i {
      display: flex;
      flex-direction: column;
      margin-left: 6px;
      i {
        display: inline-block;
        height: 10px;
      }
    }
    .shai_name {
      cursor: pointer;
      &:hover {
        color: #009999;
      }
    }
    .shai_name_active {
      color: #009999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/list/serviceList.vue